import { Injectable } from '@angular/core';
import { ApiService } from '../api-service/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ProfileService {

	private _profile: BehaviorSubject<any>

  	constructor(private apiService: ApiService) {

  		this._profile = new BehaviorSubject({})

  	}

  	get profile(){
  		return this._profile
  	}

  	set profile(data){
  		this._profile.next(data)
  	}


  	retrieveProfile(){
  		return new Promise((resolve, reject) => {
  			this.apiService.request('GET', '/staff/:adminId', {adminId: this.apiService.adminId})
	  		.then((response)=>{
	  			this._profile.next(response)
	  			resolve()
	  		})
	  		.catch(error=>{
	  			console.log(error)
	  			reject(error.message)
	  		})

  		})
  		
  	}

}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/worryandpeace/valhalla/src/app/profile-service/profile.service.ts